module.exports = __webpack_public_path__ + "img/shahs.500d5ba2.jpg";